import { Message } from 'primeng/api';

export class AlertMessage implements Message {

    public show    : boolean = false;
    public severity: string;
    public text    : string;

    public reset() {

        this.show     = false;
        this.severity = null;
        this.text     = null;

    }

    public showAlert(severity: string, message: string) {

        this.severity = severity;
        this.text     = message;
        this.show     = true;

    }

    public showDangerAlert(message: string) {

        this.showAlert('error', message);

    }

    public showWarningAlert(message: string) {

        this.showAlert('warn', message);

    }

    public showSuccessAlert(message: string) {

        this.showAlert('success', message);

    }

    public showInfoAlert(message: string) {

        this.showAlert('info', message);

    }

}
